import { DATE_VALIDATION_TYPE } from '@/utils/constants/commonConstants'

export const CreateBulkModifiersSchemas = {
  bulkModifierSetupJsonSchema: {
    type: 'object',
    properties: {
      bulkModifierName: {
        type: 'string',
      },
      storeSelector: {
        type: 'string',
      },
    },
  },
  bulkModifierSetupUISchema: (formData)=> { return {
    type: 'VerticalLayout',
    className: '',
    elements: [
      {
        type: 'HorizontalLayout',
        elements: [
          {
            type: 'Control',
            scope: '#/properties/bulkModifierName',
            component: 'TextField',
            label: 'Bulk Modifier Name*',
            placeholder: 'Add Bulk Modifier Name',
            isDark: true,
            disabled: formData?.status!=null,
            className: 'text-sm',
            validationRules: [
              { type: 'required', msg: ` is required` },
              { type: 'pattern', msg: ` special characters not allowed`, regex: '^([a-zA-Z0-9 ]+)$' },
            ],
          },
          {
            type: 'Control',
            scope: '#/properties/storeSelector',
            component: 'dropdownControl',
            label: 'Store Selector*',
            className: 'text-sm box-size-width',
            placeholder: 'Choose store selector',
            isDark: true,
            validationRules: [{ type: 'required', msg: ` is required` }],
          },
        ],
      },
    ],
  }},

  rulesJsonSchema: {
    type: 'object',
    properties: {
      actions: {
        type: 'string',
      },
    },
  },
  rulesUISchema: {
    type: 'HorizontalLayout',
    className: '',
    elements: [
      {
        type: 'HorizontalLayout',
        elements: [
          {
            type: 'Control',
            scope: '#/properties/actions',
            component: 'dropdownControl',
            label: 'Action*',
            placeholder: 'Choose Action',
            className: 'text-sm box-size-width',
            isDark: true,
          },
        ],
      },
    ],
  },

  numOfDaysSchema: {
    type: 'object',
    properties: {
      numberOfDays: {
        type: 'string',
      },
    },
  },
  numOfDaysUISchema: {
    type: 'HorizontalLayout',
    className: '',
    elements: [
      {
        type: 'HorizontalLayout',
        elements: [
          {
            type: 'Control',
            scope: '#/properties/numberOfDays',
            component: 'TextField',
            label: 'Number of days*',
            placeholder: 'Type number of days',
            isDark: true,
            className: 'text-sm',
            validationRules: [
              { type: 'required', msg: ' is required' },
              { type: 'number', msg: ' must be a number' },
              { type: 'pattern', msg: `should be a number greater than zero`, regex: '^([1-9][0-9]*)$'},
            ],
          },
        ],
      },
    ],
  },

  numOfPointsSchema: {
    type: 'object',
    properties: {
      numOfPoints: {
        type: 'string',
      },
    },
  },
  numOfPointsUISchema: {
    type: 'HorizontalLayout',
    className: '',
    elements: [
      {
        type: 'HorizontalLayout',
        elements: [
          {
            type: 'Control',
            scope: '#/properties/numberOfPoints',
            component: 'TextField',
            label: 'Number of points*',
            placeholder: 'Type number of points',
            isDark: true,
            validationRules: [
              { type: 'required', msg: ` is required` },
              { type: 'number', msg: ` must be a number` },
              { type: 'pattern', msg: `should be a number greater than zero`, regex: '^([1-9][0-9]*)$'},
            ],
          },
        ],
      },
    ],
  },

  scheduleJsonSchema: {
    type: 'object',
    properties: {
      schedule: {
        type: 'string',
      },
    },
  },
  scheduleUISchema: {
    type: 'HorizontalLayout',
    className: '',
    elements: [
      {
        type: 'HorizontalLayout',
        elements: [
          {
            type: 'Control',
            scope: '#/properties/schedule',
            component: 'dropdownControl',
            label: 'Schedule*',
            className: 'text-sm box-size-width',
            placeholder: 'Custom schedule',
            isDark: true,
            validationRules: [
              { type: 'required', msg: ` is required` },
            ],
          },
        ],
      },
    ],
  },

  startDateJsonSchema: {
    type: 'object',
    properties: {
      startDate: {
        type: 'string',
      },
    },
  },
  startDateUISchema: {
    type: 'HorizontalLayout',
    className: '',
    elements: [
      {
        type: 'HorizontalLayout',
        elements: [
          {
            type: 'Control',
            scope: '#/properties/startDate',
            component: 'datepicker',
            label: 'Start Date*',
            placeholder: '',
            isDark: true,
            required: false,
            validationRules: [
              { type: 'required', msg: ` is required` },
              { type: DATE_VALIDATION_TYPE.START_DATE, msg: ` cannot be in the past.` },
            ],
          },
        ],
      },
    ],
  },

  endDateJsonSchema: {
    type: 'object',
    properties: {
      endDate: {
        type: 'string',
      },
    },
  },
  endDateUISchema: (startDate, schedule) => ({
    type: 'HorizontalLayout',
    className: '',
    elements: [
      {
        type: 'HorizontalLayout',
        elements: [
          {
            type: 'Control',
            scope: '#/properties/endDate',
            component: 'datepicker',
            label: 'End Date*',
            placeholder: '',
            isDark: true,
            required: false,
            dependentDate: startDate,
            validationRules: [
              { type: 'required', msg: ` is required` },
              { type: DATE_VALIDATION_TYPE.START_DATE, msg: ` cannot be in the past.` },
              { type: DATE_VALIDATION_TYPE.END_DATE, msg: ` cannot be less than Start date.`, startDate: startDate },
              { type: DATE_VALIDATION_TYPE.SCHEDULE, msg: ` cannot be greater than current month.`, schedule: schedule },
              {
                type: DATE_VALIDATION_TYPE.SCHEDULE_YEAR,
                msg: ` cannot be greater than current year.`,
                schedule: schedule,
              },
            ],
          },
        ],
      },
    ],
  }),
}
